"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var prop_types_1 = require("prop-types");

var index_1 = require("../../index");

require("./index.css");

var Select = function (_a) {
  var basic = _a.basic,
      characterLimit = _a.characterLimit,
      className = _a.className,
      disabled = _a.disabled,
      error = _a.error,
      field = _a.field,
      form = _a.form,
      helperText = _a.helperText,
      helperIcon = _a.helperIcon,
      helperIconColor = _a.helperIconColor,
      label = _a.label,
      omitEmpty = _a.omitEmpty,
      onChange = _a.onChange,
      options = _a.options,
      optionTestId = _a.optionTestId,
      placeholder = _a.placeholder,
      required = _a.required,
      selectTestId = _a.selectTestId,
      optiongroup = _a.optiongroup,
      value = _a.value,
      maxWidth = _a.maxWidth,
      props = __rest(_a, ["basic", "characterLimit", "className", "disabled", "error", "field", "form", "helperText", "helperIcon", "helperIconColor", "label", "omitEmpty", "onChange", "options", "optionTestId", "placeholder", "required", "selectTestId", "optiongroup", "value", "maxWidth"]);

  var _b = (0, react_1.useState)(false),
      focus = _b[0],
      setFocus = _b[1];

  function getText(option) {
    var text = typeof option === 'string' ? option : option.label || option.value;

    if (characterLimit && text.length > characterLimit - 3) {
      text = text.substring(0, characterLimit - 3) + "...";
    }

    return text;
  }

  function getOptionTestId(val) {
    if (val === void 0) {
      val = '';
    }

    var id = "option-" + val;
    return selectTestId ? selectTestId + "-" + id : id;
  }

  function getOption(option) {
    var v = typeof option === 'string' ? option : option.value;
    var o = getOptionTestId(v);
    return (0, jsx_runtime_1.jsx)("option", __assign({
      "data-testid": o,
      value: v
    }, {
      children: getText(option)
    }), v);
  }

  function onBlur() {
    setFocus(false);
    if (form && form.setFieldTouched) form.setFieldTouched(field.name, true);
  }

  var renderHelperText = function () {
    return helperText && (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "helper-text"
    }, {
      children: [helperIcon && (0, jsx_runtime_1.jsx)(index_1.Icon, {
        name: helperIcon,
        className: "fill helper-icon icon-" + helperIconColor,
        width: 16
      }, void 0), helperText]
    }), void 0);
  };

  var classes = 'select-component';
  if (basic) classes += ' basic';
  if (focus) classes += ' focus';
  if (className) classes += " " + className;
  if (error) classes += ' error';
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: classes
  }, {
    children: [label && (0, jsx_runtime_1.jsxs)("label", __assign({
      className: "select-label",
      htmlFor: field.name,
      "data-testid": "select-label-" + field.name
    }, {
      children: [label, basic && renderHelperText()]
    }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: "select-container"
    }, {
      children: [!basic && error && (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "a-form-error",
        "data-testid": "text-input-validation-message-" + field.name
      }, {
        children: [(0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "alert",
          className: "fill icon-error input-error-icon",
          "data-testid": field.name + "-error-icon",
          width: 16
        }, void 0), error]
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "select-element"
      }, {
        children: (0, jsx_runtime_1.jsxs)("select", __assign({
          "data-testid": selectTestId,
          disabled: disabled,
          onBlur: onBlur,
          onChange: onChange,
          onFocus: function () {
            return setFocus(true);
          },
          value: value,
          style: {
            maxWidth: maxWidth
          }
        }, props, {
          children: [!omitEmpty && (0, jsx_runtime_1.jsx)("option", __assign({
            "data-testid": getOptionTestId(),
            value: ""
          }, {
            children: placeholder
          }), void 0), optiongroup ? optiongroup.map(function (group) {
            var typeOptions = options.filter(function (option) {
              return option.type === group.type;
            });
            return (0, jsx_runtime_1.jsx)("optgroup", __assign({
              "data-testid": selectTestId + "-" + "optgroup-" + group.type,
              label: group.label
            }, {
              children: typeOptions.map(getOption)
            }), group.type);
          }) : options.map(getOption)]
        }), void 0)
      }), void 0)]
    }), void 0)]
  }), void 0);
};

Select.propTypes = {
  basic: prop_types_1.bool,
  characterLimit: prop_types_1.number,
  className: prop_types_1.string,
  disabled: prop_types_1.bool,
  error: prop_types_1.string,
  field: (0, prop_types_1.shape)({
    name: prop_types_1.string,
    value: prop_types_1.string,
    onChange: prop_types_1.func
  }),
  helperIcon: prop_types_1.string,
  helperIconColor: prop_types_1.string,
  helperText: prop_types_1.string,
  label: prop_types_1.string,
  omitEmpty: prop_types_1.bool,
  onChange: prop_types_1.func.isRequired,
  // This is an array where each element is either a string
  // or an object with label and value properties.
  options: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({
    label: prop_types_1.string,
    value: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number])
  })])).isRequired,
  optiongroup: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    label: prop_types_1.string,
    type: prop_types_1.number
  })),
  optionTestId: prop_types_1.string,
  placeholder: prop_types_1.string,
  required: prop_types_1.bool,
  selectTestId: prop_types_1.string,
  value: prop_types_1.string,
  maxWidth: prop_types_1.string
};
Select.defaultProps = {
  characterLimit: 0,
  className: null,
  disabled: false,
  error: '',
  field: {
    name: 'select',
    value: '',
    onChange: function () {}
  },
  helperIcon: '',
  helperIconColor: '',
  helperText: '',
  omitEmpty: false,
  optiongroup: undefined,
  optionTestId: '',
  placeholder: '',
  required: false,
  selectTestId: '',
  value: '',
  maxWidth: ''
};
exports.default = Select;